var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPacks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3C12.5 2.44772 12.0523 2 11.5 2H3.75C2.77875 2 2 2.7875 2 3.75V11.5C2 12.0523 2.44772 12.5 3 12.5H3.75V4.75C3.75 4.19772 4.19772 3.75 4.75 3.75H12.5V3ZM16 6.5C16 5.94772 15.5523 5.5 15 5.5H7.25C6.27875 5.5 5.5 6.2875 5.5 7.25V15C5.5 15.5523 5.94772 16 6.5 16H7.25V8.25C7.25 7.69772 7.69772 7.25 8.25 7.25H16V6.5ZM17.5 9C16.5375 9 11.4712 9 10.5 9C9.52875 9 8.75 9.7875 8.75 10.75C8.75 10.75 8.75 16.7875 8.75 17.75C8.75 18.7125 9.52875 19.5 10.5 19.5C11.4712 19.5 16.5375 19.5 17.5 19.5C18.4625 19.5 19.25 18.7125 19.25 17.75C19.25 16.7875 19.25 11.7125 19.25 10.75C19.25 9.7875 18.4625 9 17.5 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacks);
export default __webpack_public_path__ + "static/media/packs.825057921f042f968ca7c3d221a92a38.svg";
export { ForwardRef as ReactComponent };